import { render, staticRenderFns } from "./UISlider.vue?vue&type=template&id=b55db8bc&"
import script from "./UISlider.vue?vue&type=script&lang=ts&"
export * from "./UISlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports